import React from 'react';
import { BookOpenIcon, ShieldCheckIcon, CalendarIcon, MessageSquareIcon } from 'lucide-react';
export function WhatsInsideSection() {
  const contents = [{
    icon: BookOpenIcon,
    title: '30 recetas para diferentes edades y texturas',
    description: 'Desde purés hasta finger foods, organizadas por etapa'
  }, {
    icon: ShieldCheckIcon,
    title: 'Guía de seguridad y prevención de atragantamientos',
    description: 'Aprende a identificar texturas seguras y cómo actuar'
  }, {
    icon: CalendarIcon,
    title: 'Plan semanal y batch cooking',
    description: 'Cocina menos, organízate mejor, ahorra tiempo'
  }, {
    icon: MessageSquareIcon,
    title: 'Tips diarios y respuestas a dudas comunes',
    description: 'Todo claro, corto y práctico'
  }];
  return <section id="recetas" className="py-12 sm:py-16 md:py-20 bg-gradient-to-br from-baby-pink-light to-baby-cream" data-id="element-1349">
      <div className="max-w-6xl mx-auto px-4 sm:px-6" data-id="element-1350">
        <div className="text-center mb-8 sm:mb-12 animate-fade-in-up" data-id="element-1351">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-1352">
            Lo Que Hay Dentro
          </h2>
          <p className="text-base sm:text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-1353">
            Un vistazo completo al contenido del ebook
          </p>
        </div>

        {/* Content Preview Collage Image */}
        <div className="mb-8 sm:mb-12 animate-fade-in-up" style={{
        animationDelay: '0.2s'
      }} data-id="element-1354">
          <div className="relative rounded-baby-lg overflow-hidden shadow-baby-glow" data-id="element-1355">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/1hu6wCYNN9paA2GZL2ZVeK/3-Collage_de_texturas.png" alt="Vista previa del contenido del ebook - Recetas, índice, texturas por edad y más" className="w-full h-auto" data-id="element-1356" />
          </div>
        </div>

        {/* Content Cards */}
        <div className="grid sm:grid-cols-2 gap-6 sm:gap-8 stagger-children" data-id="element-1357">
          {contents.map((content, index) => {
          const Icon = content.icon;
          return <div key={index} className="bg-white/90 backdrop-blur-baby p-6 sm:p-8 rounded-baby-lg border-2 border-baby-pink-light/50 shadow-baby-pink hover:shadow-baby-glow transition-all" data-id="element-1358">
                <div className="flex items-start gap-4" data-id="element-1359">
                  <div className="flex-shrink-0 w-12 h-12 sm:w-14 sm:h-14 bg-baby-gradient-pink rounded-baby flex items-center justify-center shadow-baby-soft" data-id="element-1360">
                    <Icon className="w-6 h-6 sm:w-7 sm:h-7 text-white" data-id="element-1361" />
                  </div>
                  <div data-id="element-1362">
                    <h3 className="font-bold text-base sm:text-lg md:text-xl text-gray-900 mb-2" data-id="element-1363">
                      {content.title}
                    </h3>
                    <p className="text-sm sm:text-base text-gray-600 leading-relaxed" data-id="element-1364">
                      {content.description}
                    </p>
                  </div>
                </div>
              </div>;
        })}
        </div>

        <div className="mt-8 sm:mt-12 text-center animate-fade-in-up" style={{
        animationDelay: '0.4s'
      }} data-id="element-1365">
          <div className="inline-block bg-white/90 backdrop-blur-baby border-2 border-baby-pink px-6 py-3 sm:px-8 sm:py-4 rounded-full shadow-baby-soft" data-id="element-1366">
            <p className="text-lg sm:text-xl font-bold text-gray-900" data-id="element-1367">
              Todo claro, corto y práctico.
            </p>
          </div>
        </div>
      </div>
    </section>;
}